import companiesDetailComponent from './companies-detail.component';

const companiesDetailModule = angular
  .module('companiesDetailModule' , [])
  .component('companiesDetail', companiesDetailComponent);

export default companiesDetailModule;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/companies/companies-detail/companies-detail.js
 **/